import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseFormControlComponent } from '../base-form-control.component';

@Component({
  selector: 'boi-form-text-input',
  templateUrl: './form-text-input.component.html',
  styleUrls: ['./form-text-input.component.scss']
})
export class FormTextInputComponent extends BaseFormControlComponent {
  @Input() public fieldMaxLength?: number;
  @Input() public forceRequired = false;
  @Input() public digitsOnly: boolean;
  @Output() public readonly blurChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    super();
  }

  public ensureTrimmedValue(value: any): any {
    return value !== null && typeof value === 'string' ? value.trim() : value;
  }
}
